import { render, staticRenderFns } from "./HorizontalInputs.vue?vue&type=template&id=4c1e0f43&scoped=true"
import script from "./HorizontalInputs.vue?vue&type=script&lang=js"
export * from "./HorizontalInputs.vue?vue&type=script&lang=js"
import style0 from "./HorizontalInputs.vue?vue&type=style&index=0&id=4c1e0f43&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1e0f43",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c1e0f43')) {
      api.createRecord('4c1e0f43', component.options)
    } else {
      api.reload('4c1e0f43', component.options)
    }
    module.hot.accept("./HorizontalInputs.vue?vue&type=template&id=4c1e0f43&scoped=true", function () {
      api.rerender('4c1e0f43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/rubricSetting/Add/components/HorizontalInputs.vue"
export default component.exports